import { FC, useEffect, useState } from 'react';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import gtm from '@/utils/gtm';
import { EU_SITES } from '@/constants/membersday';

interface IProps {
    type?: string;
    list: any[];
}

const Banner: FC<IProps> = ({ list = [] }) => {
    const { locale } = getLocal();
    const [activeId, setActiveId] = useState(list[0]?.href);
    const [fixH, setFixH] = useState(0);

    const handleClickTab = (item: any) => {
        setActiveId(item.href);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            button_name: item.title,
            list_name: 'none',
        });
    };

    const initFnA = () => {
        let h = 0;
        const bar = document.querySelector('.announcement-bar') as HTMLElement;
        if (bar) {
            const styles = window.getComputedStyle(bar);
            const position = styles.position;
            h += Number(position === 'sticky' ? bar?.offsetHeight : 0) || 0;
        }
        const header = document.querySelector('.ecoflow-frame-header') as HTMLElement;
        if (header) {
            const styles = window.getComputedStyle(header);
            const position = styles.position;
            h += Number(position === 'sticky' ? header?.offsetHeight : 0) || 0;
        }
        setFixH(h);
    };

    useEffect(() => {
        initFnA();
    }, [list.length]);

    useEffect(() => {
        const fn = (id: string) => {
            const target = document.querySelector(`#${id}`) as HTMLDivElement;
            AniContainer.create({
                triggerElement: `#${id}`,
                triggerHook: 1,
                offset: 0,
                onEnter: () => setActiveId(id),
                // onLeave: () => setActiveId(list[0]?.href),
                duration: target?.offsetHeight,
            });
        };
        if (typeof window !== 'undefined' && window?.AniContainer) {
            setTimeout(() => {
                list?.map((item: any) => fn(item?.href));
            }, 1000);
        }
    }, [list]);

    useEffect(() => {
        // setTimeout(() => {
        // const archor = document.querySelector('#teaser-nav-common .bar-anchor-in') as HTMLElement;
        // const items = document.querySelectorAll('#teaser-nav-common .bar-anchor-in .bar-anchor-item') as HTMLElement;
        // const gap = window.innnerWidth > 1440 ? 50 : window.innerWidth > 1024 ? 40 : 30;
        // const padding = window.innerWidth >= 768 ? 48 : 24;
        // let itemsW = 0;
        // for (let i = 0; i < items?.length; i++) {
        //     itemsW += gap + items[i].offsetWidth;
        // }
        // itemsW += padding * 2 - gap;
        // if (archor?.offsetWidth < itemsW) {
        //     const target = document.querySelector('#teaser-nav-common .bar-anchor-in .bar-anchor-item-hover') as HTMLElement;
        //     archor.scrollLeft = target?.offsetLeft - padding;
        // }
        // }, 500);

        const archor = document.querySelector('#teaser-nav-common .bar-anchor-in') as HTMLElement;
        const items = document.querySelectorAll('#teaser-nav-common .bar-anchor-in .bar-anchor-item') as HTMLElement;
        const gap = window.innnerWidth > 1440 ? 50 : window.innerWidth > 1024 ? 40 : 30;
        const padding = window.innerWidth >= 768 ? 48 : 24;
        let itemsW = 0;
        for (let i = 0; i < items?.length; i++) {
            itemsW += gap + items[i].offsetWidth;
        }
        itemsW += padding * 2 - gap;
        if (archor?.offsetWidth < itemsW) {
            const target = document.querySelector('#teaser-nav-common .bar-anchor-in .bar-anchor-item-hover') as HTMLElement;
            if (activeId === list[0].href) {
                archor.scrollLeft = 0;
            }
            if (activeId === list[list.length - 1].href) {
                archor.scrollLeft = target?.offsetLeft - padding;
            }
        }
    }, [activeId, list]);

    useEffect(() => {
        if (typeof window !== 'undefined' && window.location.hash) {
            setActiveId(window.location.hash.slice(1));
        }
    }, []);

    if (list.length === 0) {
        return null;
    }
    return (
        <div
            className={`${styled.Banner} ${EU_SITES.includes(locale) ? ' bar-anchor-eu' : ''} `}
            id="teaser-nav-common"
            style={{
                top: `${fixH}px`,
            }}
        >
            <ul className="bar-anchor-in" key={list.length}>
                {list.map((item: any, index: number) => {
                    return (
                        <li
                            className={`bar-anchor-item ${activeId === item.href ? 'bar-anchor-item-hover' : ''}`}
                            key={index}
                            onClick={() => handleClickTab(item)}
                        >
                            <a href={`#${item.href}`}>{item.title}</a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default Banner;
